import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Copy, ShieldCheck } from "lucide-react";

export default function VideoCall() {
  const { room } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const name = encodeURIComponent(user?.name || "FSCD Member");
  const src = `https://meet.jit.si/${room}#userInfo.displayName=%22${name}%22&config.prejoinConfig.enabled=false&config.startWithAudioMuted=true`;

  const copyLink = () => {
    navigator.clipboard.writeText(`${window.location.origin}/call/${room}`).then(() => toast.success("Call link copied — share it with participants"));
  };

  return (
    <div className="space-y-3" data-testid="video-call-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <button data-testid="call-back-btn" onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-sm text-teal-700 font-semibold">
          <ArrowLeft size={15} /> Back
        </button>
        <div className="flex items-center gap-2">
          <span className="text-[11px] text-slate-400 hidden sm:flex items-center gap-1"><ShieldCheck size={13} className="text-emerald-500" /> Encrypted video via Jitsi Meet</span>
          <button data-testid="copy-call-link-btn" onClick={copyLink}
            className="h-9 px-3.5 rounded-xl border border-teal-700 text-teal-800 text-xs font-semibold inline-flex items-center gap-1.5 hover:bg-teal-50 transition-colors">
            <Copy size={13} /> Copy call link
          </button>
        </div>
      </div>
      <div className="bg-slate-900 rounded-2xl overflow-hidden shadow-lg">
        <iframe
          data-testid="jitsi-frame"
          title={`FSCD video call ${room}`}
          src={src}
          allow="camera; microphone; fullscreen; display-capture; autoplay; clipboard-write"
          className="w-full border-0"
          style={{ height: "calc(100vh - 240px)", minHeight: "480px" }}
        />
      </div>
      <p className="text-[11px] text-slate-400">Room: <span className="font-mono">{room}</span> · Anyone in FSCD with this link can join. Close the tab or press the red hang-up button to leave.</p>
    </div>
  );
}
